export default __webpack_public_path__ + "static/media/Cattura3.a0b3f5b5.jpg";